
import React, { Component } from 'react';

import TermsAndConditions from './TermsAndConditions';

const TnC = ({type}) => {
  let t = <TermsAndConditions />;

  switch (type) {
    case 'customer':
      t = <TermsAndConditions />
      break;
  }
  return t;
};

export default TnC
